// extracted by extract-css-chunks-webpack-plugin
module.exports = {"play-button":"_1Nk_V","video-wrapper":"xVYe1"};